// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3d2ad573","153":"3ea2edb3","233":"de097e3d","284":"9fe27839","510":"9a4b5f50","646":"6f909a9d","808":"239313fc","878":"e67cf70b"}[chunkId] + ".chunk.js";
};